import Device from 'constants/deviceSizes';
import { textInput } from 'constants/fonts';
import { appConfig } from 'config/customization';

export default {
  formContainer: {
    boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.3)',
    borderRadius: 4,
    backgroundColor: appConfig.colors.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'auto',
    padding: `${appConfig.authLogoInForm ? 50 : 30}px 30px 30px`,
    [Device.mobile]: {
      width: '100%',
      boxSizing: 'border-box'
    }
  },
  title: {
    width: '100%',
    textAlign: 'center',
    [Device.desktop_tablet]: {
      whiteSpace: 'nowrap'
    },
    [Device.mobile]: {
      fontSize: textInput
    }
  }
};
